module.exports = __webpack_public_path__ + "img/360du.aadc1e15.png";